import React from 'react';
import { ButtonProps } from '../../types';
import styles from './button.module.css';

const Button: React.FC<ButtonProps> = ({ 
  children, 
  variant = 'primary', 
  onClick, 
  className = '', 
  type = 'button',
  disabled = false
}) => {
  const buttonClass = `${styles.button} ${styles[variant]} ${className}`.trim();
  
  return (
    <button 
      className={buttonClass} 
      onClick={onClick}
      type={type}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default Button; 